export default __webpack_public_path__ + "static/media/deposit_graph.f4a9ca41.svg";